import Vue from 'vue'
import Vuex from 'vuex'

import ModuleBuilder from './builders/ModuleBuilder'
import uid from './uid'
import options from './options'
import quote from './quote'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bookings: ModuleBuilder.Rest('bookings'),
    owners: ModuleBuilder.Rest('owners'),
    boats: ModuleBuilder.Rest('boats'),
    quote,
    uid,
    options
  }
})
